import authReducer from './auth'
import cartReducer from './cartReducers';
import categoryReducer from './category';
import commonReducer from './common';
import dashboardReducer from './dashboard';
import orderReducer from './orderReducer';
import { orderCreateReducer, orderDeleteReducer, orderDeliverReducer, orderListReducer, orderMineListReducer, orderPayReducer, orderSummaryReducer } from './orderReducers';
import productReducer from './products';

const reducers = {
  auth: authReducer,
  products: productReducer,
  categories: categoryReducer,
  common: commonReducer,
  cart: cartReducer,
  dashboard: dashboardReducer,
  order: orderReducer,
  orderCreated: orderCreateReducer,
  orderDetail: orderDeleteReducer,
  orderPay: orderPayReducer,
  orderMineList: orderMineListReducer,
  orderList: orderListReducer,
  orderDelete: orderDeleteReducer,
  orderDeliver: orderDeliverReducer,
  orderSummary: orderSummaryReducer,
}
export default reducers;
